module.exports = __webpack_public_path__ + "static/media/10102020-haywire-weekend-ski.a40c5f91.mp4";